import type { Sale } from "../sales/SaleInfo";

interface ISaleSectionsInfo {
  saleNames: string[];
  locations: string[];
}

export default function getSaleSectionsInfo(sale: Sale): ISaleSectionsInfo {
  const saleNames = [];
  const locations = [];

  sale.sections.map((section) => {
    saleNames.push(section.saleName);
    locations.push(section.locations);
  });

  return {
    saleNames: [...Array.from(new Set(saleNames))],
    locations: [...Array.from(new Set(locations.flat()))],
  };
}
